import { firstName, WizardDone } from "@/components/wizard/done-screen";

import type { Draft } from "../../-utils/fields";

export function DoneScreen({ draft }: { draft: Draft }) {
	return (
		<WizardDone
			title={`Obrigada, ${firstName(draft.name)}!`}
			description="Recebemos o seu contato. A equipe da clínica vai falar com você pelo WhatsApp."
		/>
	);
}
